"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const styled_components_1 = __importDefault(require("styled-components"));
const Link_1 = __importDefault(require("../../../../Link"));
const appstore_sm_png_1 = __importDefault(require("../../../../../static/downloads/appstore-sm.png"));
const playstore_sm_png_1 = __importDefault(require("../../../../../static/downloads/playstore-sm.png"));
const LinkWrapper = styled_components_1.default.div `
  display: flex;
  img {
    height: 48px;
    width: 48px;
    margin: 3px 8px 0 0;
  }
`;
const AppButtons = () => {
    const { formatMessage } = (0, react_intl_1.useIntl)();
    return (react_1.default.createElement(LinkWrapper, null,
        react_1.default.createElement(Link_1.default, { href: formatMessage({ id: "buy.nowallets-app-store-link" }), newTab: true },
            react_1.default.createElement("img", { src: appstore_sm_png_1.default, alt: "app store" })),
        react_1.default.createElement(Link_1.default, { href: formatMessage({ id: "buy.nowallets-google-link" }), newTab: true },
            react_1.default.createElement("img", { src: playstore_sm_png_1.default, alt: "play store" }))));
};
exports.default = AppButtons;
//# sourceMappingURL=AppButtons.js.map